//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { RemittanceType } from './Enums';

export class RemittanceOrRefundUpdateItem extends ItemBase {
    RemittanceType?: RemittanceType;
    Amount?: number;
    CashCategoryID?: string | null;
    Payee?: string | null;
    Date?: string;
    Description?: string | null;
    PaymentMethod?: string | null;
    TaxDefinitionID?: string | null;

    constructor(initializer?: Partial<RemittanceOrRefundUpdateItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "RemittanceOrRefundUpdateItem";
}
